import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { IActivityLogProps } from '../../order/order-interfaces';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { DateComponent } from '../../../components/DateComponent';

export enum ActivityLogTableAccessorKeys {
	name = 'name',
	category = 'category',
	date = 'createdOn',
	tenantId = 'tenantId',
	correlationId = 'correlationId'
}

export const defaultActivityLogColumnSizing: ColumnSizing = {
	[ActivityLogTableAccessorKeys.name]: 120,
	[ActivityLogTableAccessorKeys.category]: 120,
	[ActivityLogTableAccessorKeys.date]: 80,
	[ActivityLogTableAccessorKeys.tenantId]: 100,
	[ActivityLogTableAccessorKeys.correlationId]: 100,
};

export const defaultActivityLogColumns: MRT_ColumnDef<IActivityLogProps>[] = [
	{
		accessorKey: ActivityLogTableAccessorKeys.name,
		header: 'Order id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Order id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 fc-text-overflow">{renderedCellValue}</div>
			</TableCell>
		)
	},
	{
		accessorKey: ActivityLogTableAccessorKeys.category,
		header: 'Category',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Category</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 fc-text-overflow">{renderedCellValue}</div>
			</TableCell>
		)
	},
	{
		accessorKey: ActivityLogTableAccessorKeys.date,
		header: 'Date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black w-100px"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<DateComponent
					value={renderedCellValue}
					isTime
				/>
			</TableCell>
		)
	},
	{
		accessorKey: ActivityLogTableAccessorKeys.tenantId,
		header: 'Tenant id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Tenant id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 fc-text-overflow">{renderedCellValue}</div>
			</TableCell>
		)
	},
	{
		accessorKey: ActivityLogTableAccessorKeys.correlationId,
		header: 'Correlation id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Correlation id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 fc-text-overflow">{renderedCellValue}</div>
			</TableCell>
		)
	},
];
